export const ShoppingBasket = () => {
  return (
    <svg width="15" height="16" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_8503_2773)">
        <path
          d="M5.00696 0.477539C6.47463 0.477628 7.66506 1.66004 7.68079 3.12402H9.13489C9.45513 3.12402 9.70064 3.41012 9.65149 3.72656L8.8136 9.11523C8.73457 9.62384 8.29706 9.99902 7.78235 9.99902H2.21594C1.7014 9.9988 1.26269 9.62372 1.18372 9.11523L0.346802 3.72656C0.297741 3.4104 0.542594 3.12449 0.862427 3.12402H2.33313C2.34885 1.66014 3.53942 0.477786 5.00696 0.477539ZM2.37903 4.7959H3.32825V3.84668H2.37903V4.7959ZM6.68665 3.84668V4.7959H7.63586V3.84668H6.68665ZM5.00696 1.52246C4.11603 1.52271 3.3927 2.23678 3.37708 3.12402H6.63586C6.62023 2.23669 5.89802 1.52255 5.00696 1.52246Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_8503_2773">
          <rect width="10" height="11" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
